import { logException } from "@wss/error-tracking";
import React from "react";
import Stars from "~/common/Stars";
interface Props {
  imgSrc: string;
  title: string;
  rating: number;
  itemNumber: string;
  minimalPageVersion?: boolean;
}
const handleToReviewsClick = (minimalPageVersion: boolean, itemNumber: string) => {
  if (minimalPageVersion) {
    window.location.href = `/product-reviews/${itemNumber}.html`;
    return;
  }
  const toReviews = document?.getElementById("reviews");
  if (!toReviews) {
    const error = new Error(`Unable to scroll to reviews. Please ensure the element is in the DOM.`);
    logException(error);
    throw error;
  }
  toReviews.scrollIntoView();
  toReviews.focus();
};
const Details = ({
  imgSrc,
  title,
  rating,
  itemNumber,
  minimalPageVersion = false
}: Props) => <>
    <div className="quicklinks-banner__thumbnail-block" style={{
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: `url(${imgSrc})`,
    backgroundRepeat: "no-repeat"
  }} />
    <div className="quicklinks-banner__title-block pr-6">
      <span className="quicklinks-banner__product-title" title={title}>
        {title}
      </span>
      <div className="quicklinks-banner__meta-block">
        {rating && rating > 0 && <button className="quicklinks-banner__reviewstars-block scroll-anchor bg-transparent border-0 cursor-pointer p-0 mb-px ml-px" onClick={() => handleToReviewsClick(minimalPageVersion, itemNumber)} type="button" data-testid="header-see-all-reviews-button">
            <span className="sr-only">See all reviews</span>
            <ul className="rating product-subhead__rating mt-[-3px]" aria-label={`Rated ${rating} out of 5 stars.`}>
              <Stars rating={rating} size="small" />
            </ul>
          </button> || null}
        <span style={{
        textTransform: "uppercase"
      }} className="quicklinks-banner__product-id text-gray-700">
          {`Item Number: ${itemNumber}`}
        </span>
      </div>
    </div>
  </>;
export default Details;